import React from 'react';
import contentConstants from 'constants/content';
import autoReplenishmentConstants from 'constants/AutoReplenishment';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box } from 'components/ui';
import ComponentList from 'components/Content/ComponentList';
import useAutoReplenishEmptyHub from 'components/RichProfile/MyAccount/AutoReplenishment/AutoReplenishEmptyHub/hooks/useAutoReplenishEmptyHub';

const { CONTEXTS } = contentConstants;
const { CARD_SIZE_CONFIG } = autoReplenishmentConstants;

/**
 * Displays the empty state hub for the Auto Replenishment page.
 * Renders CMS-driven top and middle content sections, and automatically
 * shows the sign-in modal when the user is not authenticated.
 *
 * @returns {React.ReactElement} The rendered empty hub layout.
 */
const AutoReplenishEmptyHub = () => {
    const { cmsData } = useAutoReplenishEmptyHub();

    return (
        <Box>
            {cmsData?.topContent && (
                <ComponentList
                    items={cmsData.topContent}
                    context={CONTEXTS.CONTAINER}
                />
            )}
            {cmsData?.middleContent && (
                <ComponentList
                    items={cmsData.middleContent}
                    context={CONTEXTS.CONTAINER}
                    customCardSize={CARD_SIZE_CONFIG}
                />
            )}
        </Box>
    );
};

export default wrapFunctionalComponent(AutoReplenishEmptyHub, 'AutoReplenishEmptyHub');
